export default __webpack_public_path__ + "static/media/guadeloupe.dfffa673.svg";